import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingChangeShareUser } from 'services/setting'
import posthog from 'posthog-js'

export default function useSetShareUser(refetch: (() => void) | undefined) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IChangeShareSettingPayload) => {
            return settingChangeShareUser(payload)
        },
        onSuccess: (data, variables: any) => {
            posthog.capture('member_shares_changed', {
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
            })
            refetch && refetch()
            toast.success('تغییر سهم با موفقیت انجام شد')
        },
        onError: (error: any, variables: any) => {
            posthog.capture('member_action_failed', {
                action: 'change_shares',
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
                status: error?.response?.status,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
